import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion-wrapper" }
const _hoisted_2 = { class: "accordion-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "accordion-icon" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 10.5L10 1.5L1 10.5",
  stroke: "black"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "accordion-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accordionToggle()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          innerHTML: _ctx.accordion.title
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass({'accordion-open': _ctx.isAccordionOpen}),
          fill: "none",
          height: "11",
          viewBox: "0 0 20 11",
          width: "20",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_6, 2))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{'accordion-open': _ctx.isAccordionOpen}, "accordion-description"])
    }, [
      _createElementVNode("p", {
        innerHTML: _ctx.accordion.description
      }, null, 8, _hoisted_7)
    ], 2)
  ]))
}